import React from 'react';

/**
 * The frame every Wiki screen renders in — the CRM Dashboard's, not the
 * prototype's (REBUILD-PLAN §1, Owen 2026-10-06):
 *
 *   default   lives in the shell's normal padded page scrollport
 *             (`p-3 sm:p-4 md:p-6`, `--canvas`), as a left-aligned
 *             `max-w-[1600px]` container with 24px between blocks
 *             (Dashboard `space-y-6 max-w-[1600px]`).
 *   bounded   Ask only — the route is in RuntimeShell's `isFullscreenPage`,
 *             so the shell hands it a clipped `flex-1 min-h-0` column with no
 *             padding. The frame re-applies the same 12/16/24px padding and
 *             1600px container, and makes its children a `flex-1 min-h-0`
 *             column so one region (the thread) can own the scroll while the
 *             composer stays fixed. Never `position: fixed` (memory: RuntimeShell
 *             fullscreen contract — the rail paints over fixed overlays).
 *
 * Put `<PageHeader/>` (components/page/PageHeader) first; then blocks.
 */
export default function WikiFrame({ bounded = false, className = '', children, testId, ...rest }) {
    if (bounded) {
        return (
            <div className="wk-bounded" data-testid={testId} {...rest}>
                <div className={`wk-frame wk-frame--fill ${className}`.trim()}>
                    {children}
                </div>
            </div>
        );
    }
    return (
        <div className={`wk-frame ${className}`.trim()} data-testid={testId} {...rest}>
            {children}
        </div>
    );
}
